module.exports = __webpack_public_path__ + "static/img/zxwlogo.8e882a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zxwlogo.png
// module id = MZy+
// module chunks = 1